module.exports = __webpack_public_path__ + "static/img/slaPurpose1.5d3f525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slaPurpose1.png
// module id = 7QnR
// module chunks = 2